import { WSActions, WSCard, WSList } from "@wingspanhq/fe-component-library";
import { WSCardHeaderProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSCard/WSCardHeader";
import { useState } from "react";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { List } from "./List";
import { MethodsData, MethodValue } from "./types";

export type ManageMethodsProps = {
  data: MethodsData;

  initialValue: MethodValue | undefined;
  header?: WSCardHeaderProps;
  onAddNew?: () => void;
  addNewLabel?: string;
  onSubmit: (value: MethodValue) => void;
  isLoading?: boolean;
  error?: any;
};

export const ManageMethods: React.FC<ManageMethodsProps> = props => {
  const [value, setValue] = useState<MethodValue | undefined>(
    props.initialValue
  );

  return (
    <WSList gap="2XL">
      <WSCard header={props.header}>
        <WSList gap="L">
          <List
            data={props.data}
            initialValue={props.initialValue}
            value={value}
            onChange={setValue}
          />

          {props.onAddNew && (
            <WSCard
              header={{
                label: {
                  link: {
                    icon: "plus-circle",
                    onClick: props.onAddNew,
                    label: props.addNewLabel
                  }
                }
              }}
            />
          )}
        </WSList>
      </WSCard>

      <WSErrorMessage contextKey="FundingMethod" error={props.error} />

      <WSActions
        alignment="fill"
        buttons={[
          {
            disabled: !value,
            label: "Save changes",
            onClick: () => {
              if (value) {
                props.onSubmit(value);
              }
            },
            loading: props.isLoading
          }
        ]}
      />
    </WSList>
  );
};
